
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  article: ArticleData;
  show: boolean;
}

interface Data {
  title: string | null;
}

interface Computed {
  ttsUrl: string | null;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
    };
  },
  computed: {
    ttsUrl() {
      if (this.$store.state.piano.access.channelAccess && this.article.ttsSettings.textToSpeech !== '') {
        return this.article.ttsSettings.textToSpeech;
      }

      if (this.article.ttsSettings.textToSpeechTeaser !== '') {
        return this.article.ttsSettings.textToSpeechTeaser;
      }

      return null;
    },
  },
});
